import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../components/Form/Button";
import useStyles from "./styles";

export interface DeleteInvoiceConfirmationModalHandles {
  open: (id: number, invoiceNumber?: string) => void;
  close: () => void;
}
interface DeleteInvoiceConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: (id: number) => void;
  loadingAction?: boolean;
}

const DeleteInvoiceConfirmationModal: ForwardRefRenderFunction<
  DeleteInvoiceConfirmationModalHandles,
  DeleteInvoiceConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [idValue, setIdValue] = useState<number>(0);
  const [invoiceValue, setInvoiceValue] = useState("");
  const open = useCallback((id: number, InvoiceValue?: string) => {
    if (id) setIdValue(id);
    if (InvoiceValue) setInvoiceValue(InvoiceValue);
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setIdValue(0);
    setInvoiceValue("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));
  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };
  const onDelete = () => {
    onSubmit(idValue);
  };

  return (
    <ConfirmationModal
      data-cy="delete-modal"
      width="520px !important"
      open={openModal}
      closeModal={onClose}
      type="error"
      title={translate("deleteInvoice")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("noThanks")}
      textSubmit={translate("deleteInvoice")}
      submit={onDelete}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.cancelModalContainer}>
          <div data-cy="confirmationModalCancelBody" className={classes.descriptionModalConfirm}>
            <span>
              {translate("areYouSureYouWantToDeleteTheInvoice")} {`${invoiceValue}`}?
            </span>
            <span className="error">{translate("thisActionIsPermanentAndCannotBeUndone")}</span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(DeleteInvoiceConfirmationModal);
